import { Link } from "react-router-dom";
import backarrow from "../assets/images/back-arrow.png";
import LoadingButton from "./LoadingButton";
const ContentLayoutHeader = ({
  heading,
  handleCancel,
  navigationLink,
  btnText,
  loading,
  disabled,
}) => {
  return (
    <div className={`stickyy mng-header`}>
      <div>
        <Link to={navigationLink}>
          <span className="backbtn">
            <img src={backarrow} alt="back"></img>
          </span>
        </Link>
        <span className="txt-blue bold fs-18">{heading}</span>
      </div>

      <div className="d-flex-align-cent">
        <button type="button" className="cancelbtn mr-2" onClick={handleCancel}>
          Cancel
        </button>
        <LoadingButton text={btnText} loading={loading} disabled={disabled} />
      </div>
    </div>
  );
};

export default ContentLayoutHeader;
